<template>
	<layout-main>
		<template #toolbar>
			<v-app-bar app dark>
				<v-app-bar-nav-icon v-if="showBackBtn">
					<v-icon @click.native.stop="backFn">fa-arrow-left</v-icon>
				</v-app-bar-nav-icon>
				<v-spacer />
				<v-toolbar-title>{{ strings.install.title }}</v-toolbar-title>
				<v-spacer />
				<slot name="rightIcon">
					<v-btn v-if="showExitBtn" icon @click="exitFn">
						<v-icon>fa-home</v-icon>
					</v-btn>
				</slot>
			</v-app-bar>
		</template>

		<v-container>
			<router-view name="header" />
			<router-view :next-fn="nextFn" />
		</v-container>

		<template #footer>
			<layout-footer @click:tab="navigate" />
		</template>
	</layout-main>
</template>

<script>
import strings from "@/utils/strings";

export default {
	props: ["showBackBtn", "showExitBtn", "nextFn", "backFn", "exitFn"],

	data: () => ({
		strings,
	}),

	methods: {
		navigate(to) {
			const communityId = this.$store.state.session.communityId;

			if (to === "community") {
				return this.$root.$router.push({
					path: "/install",
					query: { force: true },
				});
			} else if (to === "room" && communityId) {
				return this.$root.$router.push(`/install/${communityId}`);
			}
		},
	},
};
</script>
